import React from "react";
import { Form, Select, Input, Drawer, Button, Radio, message, } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import api from "utils/api";
import utils from "utils";
import "./Styles/FormMedicine.scss";
import { CONSTANTS } from "utils/constant";
import Validators from "Common/Validators";
import debounce from "lodash.debounce";
import { LoadingOutlined } from "@ant-design/icons";
import { MEASURE_OPTIONS } from "Common/constant";
import "./Styles/FormMedicine.scss";

const params = ["drug", "brand", "form", "route", "adjuvant"];
class FormAddMedicine extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search_suggestion: [],
      searchParam: "",
      default_options: [],
      medicine_data: [],
      dosage: "",
      newOption: "",
      displayField: false,
      typeSelected: "",
      typeErrorState: null,
      fetching: false,
    };
    this.form = React.createRef();
    this.type_form = React.createRef();
  }
  debouncedMedFunction = debounce((value, i) => {
    api.get_med_params(i, value).then((res) => {
      let data = res.data?.data?.results;
      this.setState({ search_suggestion: data, fetching: false });
    });
  }, 800);
  handleOnSearch(value, i) {
    this.debouncedMedFunction(value, i);
  }
  handleChangeSelect = (label, value, i) => {
    if (value?.id) {
      this.setState({ [`${i}`]: label, [`${i}_id`]: value?.id });
    } else {
      this.setState({ [`${i.value}`]: label?.target });
    }
  };
  /********** Default Options Condition**************/
  // loadDefaultOptions(e){
  //   api.get_default_options(e.target.value).then((res)=>{
  //     let data=res.data?.data?.results
  //    this.setState({default_options:data})
  //         })
  // }
  handleSubmit(values) {
    if (this.state.typeSelected == "") {
      this.setState({ typeErrorState: true });
      return;
    }

    let tempValue = {
      brand: values.brand,
      dosage: values.dosage == "na" ? "NA" : values.dosageValue?.trim() + " " + values.dosageMeasure,
      duration: values.duration.value?.trim() + " " + values.duration.measure,
      drug: values.drug,
      form: values.form,
      frequency: values.frequency,
      frequency_measurement: "",
      route: values.route,
      type: this.state.typeSelected,
      intake_instruction: values.intake_instruction,
      ...((this.state.typeSelected === "ayurveda" ||
        this.state.typeSelected === "herbal") && {
        adjuvant: values.adjuvant,
        frequency_measurement: values.frequency.measure,
      }),
    };
    // if (this.state.typeSelected == "allopathy") {
    //   tempValue["frequency"] = tempValue["frequency"].split("").join("-");
    // } else {
    tempValue["frequency"] =
      tempValue.frequency[1] +
      "-" +
      tempValue.frequency[2] +
      "-" +
      tempValue.frequency[3] +
      "-" +
      tempValue.frequency[4];
    // }
    Object.keys(tempValue).map((i) => {
      if (i != "type") {
        tempValue[`${i}_id`] = this.state?.[`${i}_id`]
          ? this.state[`${i}_id`]
          : "";
      }
    });
    api.post_add_medicine(tempValue).then((res) => {
      if (res.data.status == 200) {
        message.success(res.data.message, ErrorDuration);
        this.form.current.resetFields();
      } else {
        message.error(res.data.message, ErrorDuration);
      }
    });
  }
  selectedType(e) {
    this.form.current.resetFields();
    if (e.target.value == "allopathy") {
      params.splice(4, 1);
    } else if (
      (e.target.value == "ayurveda" || e.target.value == "herbal") &&
      !params.includes("adjuvant")
    ) {
      params.push("adjuvant");
    }
    this.setState({
      displayField: true,
      typeSelected: e.target.value,
      typeErrorState: false,
    });
  } 
  render() {
    let options = Object.values(this.state?.search_suggestion || []).map(
      (o, i) => (
        <Select.Option value={o.name} id={o.id} key={i}>
          {o.name}
        </Select.Option>
      )
    );
    return (
      <>
        <div className="App">
          {this.props.from == "care-admin" ? (
            <>
              <div className="App">
                <div className="new-med-head">Add medicine</div>
                <Form className="add-med" ref={this.type_form} labelAlign="left">
                  <Form.Item
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 24 }}
                    className="medicine-type"
                    label="Type"
                    name={"type"}
                    rules={[
                      {
                        required: true,
                        message: "Please fill the type.",
                      },
                    ]}
                  >
                    <Radio.Group onChange={(e) => this.selectedType(e)}>
                      <Radio value={"allopathy"}>Allopathy</Radio>
                      <Radio value={"ayurveda"}>Ayurveda</Radio>
                      <Radio value={"herbal"}>Herbal</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Form>
                <Form
                  labelCol={{xs:24, md: 24}}
                  wrapperCol={{xs: 24, md: 24}}
                  ref={this.form}
                  onFinish={(label, value) => this.handleSubmit(label, value)}
                  labelAlign="left"
                >
                  {this.state.displayField ? (
                    <>
                      {params.map((i, o) => {
                        return (
                          <Form.Item
                            className="prescription-selectors"
                            label={utils.ConvertToPascalCase(i)}
                            key={o}
                            name={i}
                            labelCol={{ md: 7, lg: 4 }}
                            wrapperCol={{ md: 17, lg: 24 }}
                            style={{
                              display: "contents",
                              textDecoration: "underline",
                            }}
                            rules={[
                              {
                                required: true,
                                message: "Please select the " + i,
                              },
                            ]}
                          >
                            <Select
                              placement="bottomLeft"
                              showSearch
                              allowClear
                              onClick={(e) => {
                                this.setState({
                                  searchParam: e.target.id,
                                  search_suggestion: [],
                                  newOption: "",
                                  fetching: true,
                                }),
                                  this.handleOnSearch("", i);
                              }}
                              notFoundContent={
                                this.state.fetching ? (
                                  <LoadingOutlined
                                    style={{
                                      fontSize: 18,
                                      color: "#134E48",
                                    }}
                                    spin
                                  />
                                ) : null
                              }
                              aria-autocomplete="true"
                              optionLabelProp="label"
                              defaultValue={this.state.default_options}
                              onChange={(label, value) =>
                                this.handleChangeSelect(label, value, i)
                              }
                              autoClearSearchValue={false}
                              maxTagCount={1}
                              style={{
                                width: "100%",
                                paddingLeft: "0px !important",
                                margin: "10px 0px",
                              }}
                              placeholder={
                                "Search by " + `${utils.ConvertToPascalCase(i)}`
                              }
                              onSearch={(val) => {
                                this.handleOnSearch(val, i),
                                  this.setState({
                                    newOption: val,
                                    fetching: true,
                                  });
                              }}
                              getPopupContainer={(trigger) =>
                                trigger.parentNode
                              }
                              popupClassName="bottom-positioned-dropdown"
                              optionFilterProp="children"
                            >
                              {this.state.newOption &&
                                Object.values(
                                  this.state.search_suggestion || []
                                ).filter((o) => o === this.state.newOption)
                                  .length === 0 && (
                                  <Option
                                    key={this.state.newOption}
                                    value={this.state.newOption}
                                  >
                                    {this.state.newOption}
                                  </Option>
                                )}
                              {options}
                            </Select>
                          </Form.Item>
                        );
                      })}
                      {/* {this.state.typeSelected == "allopathy" ? (
                        <Form.Item
                          labelCol={{ span: 4 }}
                          wrapperCol={{ span: 24 }}
                          rules={[
                            {
                              required: true,
                              message: "Please fill the frequency.",
                            },
                          ]}
                          name={"frequency"}
                          label={"Frequency"}
                        >
                          <OtpInput
                            separator={<span>-</span>}
                            numInputs={4}
                            isInputNum={true}
                            className="otp-input"
                            inputStyle={{
                              margin: "0px 4px",
                              width: "28px",
                              border: "1px solid lightgray",
                              borderRadius: "5px",
                            }}
                          />
                        </Form.Item>
                      ) : ( */}
                      <Form.Item
                        name={["frequency"]}
                        label={"Frequency"}
                        labelCol={{ md: 7, lg: 4 }}
                        wrapperCol={{ md: 17, lg: 24  }}
                        rules={[
                          {
                            required: true,
                            message: "Please fill the frequency",
                          },
                          Validators.checkDecimalWithZero({type:this.state.typeSelected}), 
                        ]}
                        validateTrigger={["onChange", "onBlur"]}
                      >
                        <Input.Group style={{ display: "flex" }} compact>
                          <Form.Item
                            name={["frequency", "1"]}
                            noStyle
                            rules={[
                              {
                                required: true,
                                message: "",
                              },
                              // Validators.checkDecimalWithZero,
                            ]}
                          >
                            <Input
                            className="frequency-seperate-fields"
                              style={{
                                // width: "10%",
                              }}
                              {...({maxLength: this.state.typeSelected == "allopathy" ? 1 : 4})}
                            />
                          </Form.Item>
                          <span
                            style={{ display: "flex", alignItems: "center" , 
                            padding: "0 4px", }}
                          >
                            -
                          </span>
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: "",
                              },
                              // Validators.checkDecimalWithZero,
                            ]}
                            name={["frequency", "2"]}
                            noStyle
                          >
                            <Input
                             className="frequency-seperate-fields"
                              style={{
                                // width: "10%",
                              }}
                              {...({maxLength: this.state.typeSelected == "allopathy" ? 1 : 4})}
                            />
                          </Form.Item>
                          <span
                            style={{ display: "flex", alignItems: "center", padding: "0 4px", }}
                          >
                            -
                          </span>
                          <Form.Item
                            name={["frequency", "3"]}
                            noStyle
                            rules={[
                              {
                                required: true,
                                message: "",
                              },
                              // Validators.checkDecimalWithZero,
                            ]}
                          >
                            <Input
                            className="frequency-seperate-fields"
                              style={{
                                // width: "10%",
                              }}
                              {...({maxLength: this.state.typeSelected == "allopathy" ? 1 : 4})}
                            />
                          </Form.Item>
                          <span
                            style={{ display: "flex", alignItems: "center", padding: "0 4px", }}
                          >
                            -
                          </span>
                          <Form.Item
                            name={["frequency", "4"]}
                            noStyle
                            rules={[
                              {
                                required: true,
                                message: "",
                              },
                              // Validators.checkDecimalWithZero,
                            ]}
                          >
                            <Input
                              className="last-frequency frequency-seperate-fields"
                              style={{
                                // width: "10%",
                              }}
                              {...({maxLength: this.state.typeSelected == "allopathy" ? 1 : 4})}
                            />
                          </Form.Item>
                          {this.state.typeSelected != "allopathy" && (
                            <Form.Item
                              rules={[{ required: true, message: "" }]}
                              style={{
                                width: "10%",
                                height: "20px",
                                margin: "0px",
                                borderRadius: "0px",
                                marginLeft: "10px",
                              }}
                              name={["frequency", "measure"]}
                            >
                              <Select
                                placeholder="mg/ml"
                                style={{ borderRadius: "0px" }}
                                options={MEASURE_OPTIONS}
                              ></Select>
                            </Form.Item>
                          )}
                        </Input.Group>
                      </Form.Item>
                      {/* )} */}
                      <Form.Item
                        labelCol={{ md: 7 }}
                        wrapperCol={{ span: 17 }}
                        name={"dosage"}
                        label={"Dosage"}
                        style={{ margin: "20px 0" }}
                        rules={[
                          {
                            required: true,
                            message: "Please fill the dosage",
                          },
                        ]}
                      >
                        <Input placeholder="250 mg/500 ml" />
                      </Form.Item>
                      
                    </>
                  ) : null}
                </Form>
                <Button
                  className="confirm-btn"
                  style={{ float: "right" }}
                  onClick={() => {
                    this.form.current.submit();
                    this.type_form.current.submit();
                  }}
                >
                  Submit <ArrowRightOutlined />{" "}
                </Button>
              </div>
            </>
          ) : (
            <>
              <div
                className={!this.props?.getContainer ? "prescription-nested-drawer" : ""}
              >
                <Drawer
                  disabled={this.props.from == "care-admin" ? false : true}
                  style={{padding:"0 0 5px 0"}}
                  title="Add Medicine"
                  placement="right"
                  closable={false}
                  maskClosable={false}
                  destroyOnClose={true}
                  className="prescription-nested-drawer-width"
                  width={"50vw"}
                  open={this.props.open_drawer}
                  getContainer={this.props?.getContainer || false}
                  extra={
                    <Button
                      className="close-button"
                      onClick={() => {this.setState({displayField : false}); this.props.openDrawer(false)}}
                    >
                      {CONSTANTS.CLOSE}
                    </Button>
                  }
                >
                  <div className="App">
                    <Form
                      ref={this.type_form}
                      labelCol={{xs:24, md: 24}}
                      wrapperCol={{xs: 24, md: 24}}
                      labelAlign="left"
                      colon={false}
                      className="medicine-type-form"
                    >
                      <Form.Item
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 24 }}
                        className="medicine-type"
                        label="Type"
                        name={"type"}
                        rules={[
                          {
                            required: true,
                            message: "Please fill the type.",
                          },
                        ]}
                      >
                        <Radio.Group onChange={(e) => this.selectedType(e)}>
                          <Radio value={"allopathy"}>Allopathy</Radio>
                          <Radio value={"ayurveda"}>Ayurveda</Radio>
                          <Radio value={"herbal"}>Herbal</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Form>
                    <Form
                      ref={this.form}
                      onFinish={(label, value) =>
                        this.handleSubmit(label, value)
                      }
                      labelAlign="left"
                      initialValues={{dosage : "others"}}
                    >
                      {this.state.displayField ? (
                        <>
                          {params.map((i, o) => {
                            return (
                              <Form.Item
                                className="prescription-selectors"
                                label={utils.ConvertToPascalCase(i)}
                                key={o}
                                name={i}
                                labelCol={{ md: 7 }}
                                wrapperCol={{ md: 17 }}
                                style={{
                                  display: "contents",
                                  textDecoration: "underline",
                                  width:"80%",
                                  textOverflow:"clip"
                                  // marginBottom:"20px"
                                }}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please select the " + i,
                                  },
                                  {
                                    max: 250,
                                    message: "This field exceeds maximum number of 250 characters",
                                  }
                                ]}
                              >
                                <Select
                                  placement="bottomLeft"
                                  showSearch
                                  notFoundContent={
                                    this.state.fetching ? (
                                      <LoadingOutlined
                                        style={{
                                          fontSize: 18,
                                          color: "#134E48",
                                        }}
                                        spin
                                      />
                                    ) : (
                                      true
                                    )
                                  }
                                  aria-autocomplete="true"
                                  allowClear
                                  value={""}
                                  optionLabelProp="label"
                                  autoClearSearchValue={false}
                                  defaultValue={this.state.default_options}
                                  onChange={(label, value) =>
                                    this.handleChangeSelect(label, value, i)
                                  }
                                  onClick={(e) => {
                                    this.setState({
                                      searchParam: e.target.id,
                                      search_suggestion: [],
                                      newOption: "",
                                      fetching: true,
                                    }),
                                      this.handleOnSearch("", i);
                                  }}
                                  maxTagCount={1}
                                  style={{
                                    width: "80%",
                                    paddingLeft: "0px !important",
                                    textOverflow:"ellipsis"
                                  }}
                                  placeholder={
                                    "Search by " +
                                    `${utils.ConvertToPascalCase(i)}`
                                  }
                                  onSearch={(val) => {
                                    this.handleOnSearch(val, i),
                                      this.setState({
                                        newOption: val,
                                        fetching: true,
                                      });
                                  }}
                                  getPopupContainer={(trigger) =>
                                    trigger.parentNode
                                  }
                                  popupClassName="bottom-positioned-dropdown"
                                  optionFilterProp="children"
                                >
                                  {this.state.newOption &&
                                    this.state.search_suggestion.filter(
                                      (o) =>
                                        o?.name?.toLowerCase() ===
                                        this.state.newOption?.toLocaleLowerCase()
                                    ).length === 0 && (
                                      <Option
                                        key={this.state.newOption}
                                        value={this.state.newOption}
                                      >
                                        {this.state.newOption}
                                      </Option>
                                    )}
                                  {options}
                                </Select>
                              </Form.Item>
                            );
                          })}
                          {/* {this.state.typeSelected == "allopathy" ? (
                            <Form.Item
                              labelCol={{ span: 4 }}
                              wrapperCol={{ span: 24 }}
                              name={"frequency"}
                              label={"Frequency"}
                              rules={[
                                {
                                  required: true,
                                  message: "Please fill the frequency.",
                                },
                              ]}
                            >
                              <OtpInput
                                separator={<span>-</span>}
                                numInputs={4}
                                isInputNum={true}
                                className="otp-input"
                                inputStyle={{
                                  margin: "0px 4px",
                                  width: "28px",
                                  border: "1px solid lightgray",
                                  borderRadius: "5px",
                                }}
                              />
                            </Form.Item>
                          ) : ( */}
                          <Form.Item
                            labelCol={{ md: 7 }}
                            wrapperCol={{ md: 17 }}
                            name={["frequency"]}
                            label={"Frequency"}
                            rules={[
                              {
                                required: true,
                                message: "Please fill the frequency",
                              },
                              Validators.checkDecimalWithZero({type:this.state.typeSelected}), 
                            ]}
                            validateTrigger={["onChange", "onBlur"]}
                          >
                            <Input.Group style={{ display: "flex" }} compact>
                              <Form.Item
                                name={["frequency", "1"]}
                                noStyle
                                rules={[
                                  {
                                    required: true,
                                    message: "",
                                  },
                                ]}
                              >
                                <Input placeholder="Morning"
                                className="frequency-seperate-fields"
                                  style={{
                                    // width: "15%",
                                  }}
                                  {...({maxLength: this.state.typeSelected == "allopathy" ? 1 : 4})}
                                />
                              </Form.Item>
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding:"0 4px",
                                }}
                              >
                                -
                              </span>
                              <Form.Item
                                name={["frequency", "2"]}
                                noStyle
                                rules={[
                                  {
                                    required: true,
                                    message: "",
                                  },
                                ]}
                              >
                                <Input placeholder="Noon"
                                className="frequency-seperate-fields"
                                  style={{
                                    // width: "15%",
                                  }}
                                  {...({maxLength: this.state.typeSelected == "allopathy" ? 1 : 4})}
                                />
                              </Form.Item>
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding:"0 4px",
                                }}
                              >
                                -
                              </span>
                              <Form.Item
                                name={["frequency", "3"]}
                                noStyle
                                rules={[
                                  {
                                    required: true,
                                    message: "",
                                  },
                                ]}
                              >
                                <Input placeholder="Evening"
                                className="frequency-seperate-fields"
                                  style={{
                                    // width: "15%",
                                  }}
                                  {...({maxLength: this.state.typeSelected == "allopathy" ? 1 : 4})}
                                />
                              </Form.Item>
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding:"0 4px",
                                }}
                              >
                                -
                              </span>
                              <Form.Item
                                name={["frequency", "4"]}
                                noStyle
                                rules={[
                                  {
                                    required: true,
                                    message: "",
                                  },
                                ]}
                              >
                                <Input placeholder="Night"
                                  className="last-frequency frequency-seperate-fields "
                                  style={{
                                    // width: "15%",
                                  }}
                                  {...({maxLength: this.state.typeSelected == "allopathy" ? 1 : 4})}
                                />
                              </Form.Item>
                              {this.state.typeSelected != "allopathy" && (
                                <Form.Item
                                  rules={[{ required: true, message: "" }]}
                                  style={{
                                    width: "20%",
                                    height: "20px",
                                    margin: "0px",
                                    borderRadius: "0px",
                                    marginLeft: "10px",
                                  }}
                                  name={["frequency", "measure"]}
                                >
                                  <Select
                                    placeholder="mg/ml"
                                    style={{ borderRadius: "0px" }}
                                    options={MEASURE_OPTIONS}
                                  ></Select>
                                </Form.Item>
                              )}
                            </Input.Group>
                          </Form.Item>
                          {/* )} */}
                          <Form.Item
                            labelCol={{ md: 7 }}
                            wrapperCol={{ md: 17 }}
                            name="dosage"
                            label={"Dosage"}
                            // style={{ margin: "20px 0" }}
                            rules={[
                              {
                                required: true,
                                message: "Please fill the dosage",
                              },
                            ]}
                            validateTrigger={["onChange", "onBlur"]}
                          >
                           <Radio.Group style={{marginTop:"5px"}}  name="radio-group">
                              <Radio  key='others' value='others'> Applicable </Radio>
                              <Radio  key='na' value='na'>Not applicable</Radio>
                            </Radio.Group>
                            </Form.Item>
                            <Form.Item noStyle  shouldUpdate={(prevValues, currentValues) => prevValues.dosage !== currentValues.dosage }>
                            {({ getFieldValue }) => getFieldValue('dosage') === 'others' ?
                              <Form.Item colon={false}  label={' '} 
                                labelCol={{ md: 7 }} wrapperCol={{ md: 17 }}
                              >
                                  <Input.Group compact style={{ display: "flex" }}>
                                    <Form.Item name={"dosageValue"}
                                      rules={[
                                        {
                                          required: true ,
                                          message: "Please fill the dosage",
                                        },
                                        Validators.checkDecimalPrescription,
                                      ]}
                                      noStyle
                                      validateTrigger={["onChange", "onBlur"]}
                                    >
                                      <Input placeholder="Type here" maxLength={4} style={{ width: "35%", borderTopRightRadius:"6px", borderBottomRightRadius:"6px" }} />
                                    </Form.Item>
                                    <Form.Item
                                        name={"dosageMeasure"}
                                        noStyle
                                        validateTrigger={["onChange", "onBlur"]}
                                        rules={[
                                          {
                                            required: true ,
                                            message: `${getFieldValue("dosageValue")? "Please select mg/ml" : "" }`,
                                          },]}
                                    >
                                      <Select 
                                        placeholder="mg/ml"
                                        options={MEASURE_OPTIONS}
                                        style={{ width: "30%", marginLeft:"8px" }}
                                      ></Select>
                                    </Form.Item>
                                  </Input.Group>
                                </Form.Item> : null}
                          </Form.Item> 
                          <Form.Item />
                          {/* Multiple Dosage Form list items */}
                          {/* <Form.List
                            name="dosages"
                            initialValue={[{ dosage: "" }]}
                            // rules={[
                            //   {
                            //     validator: async (_, dosages) => {
                            //       if (!dosages || dosages.length < 1) {
                            //         return Promise.reject(
                            //           new Error("At least 1 dosage")
                            //         );
                            //       }
                            //     },
                            //   },
                            // ]}
                          >
                            {(fields, { add, remove }, { errors }) => (
                              <>
                                {fields.map((field, index) => (
                                  <Form.Item
                                    {...(index === 0
                                      ? formItemLayout
                                      : formItemLayoutWithOutLabel)}
                                    label={index === 0 ? "Dosage" : ""}
                                    required={true}
                                    key={field.key}
                                  >
                                    <Space
                                      // key={index}
                                      style={{
                                        display: "flex",
                                        marginBottom: 8,
                                      }}
                                    >
                                      <Form.Item
                                        {...field}
                                        name={[field.name, "dosage"]}
                                        // validateTrigger={["onChange", "onBlur"]}
                                        rules={[
                                          {
                                            required: true,
                                            whitespace: true,
                                            message: "Please fill the dosage",
                                          },
                                        ]}
                                        noStyle
                                      >
                                        <Input
                                          placeholder="Dosage"
                                          style={{
                                            width: "100%",
                                          }}
                                        />
                                      </Form.Item>
                                      <Form.Item
                                        {...field}
                                        name={[field.name, "mgml"]}
                                        // validateTrigger={["onChange", "onBlur"]}
                                        rules={[
                                          {
                                            required: true,
                                            whitespace: true,
                                            message: "Please fill mg/ml",
                                          },
                                        ]}
                                        noStyle
                                      >
                                        <Select
                                          style={{
                                            width: "120px",
                                          }}
                                          placeholder="Select mg/ml"
                                          options={[
                                            {
                                              label: "mg",
                                              value: "mg",
                                            },
                                            {
                                              label: "ml",
                                              value: "ml",
                                            },
                                          ]}
                                        />
                                      </Form.Item>
                                      {index > 0 ? (
                                        <MinusCircleOutlined
                                          className="dynamic-delete-button"
                                          onClick={() => remove(field.name)}
                                        />
                                      ) : null}
                                    </Space>
                                  </Form.Item>
                                ))}
                                <Form.Item {...formItemLayoutWithOutLabel}>
                                  <Button
                                    size="small"
                                    type="primary"
                                    onClick={() => add()}
                                    icon={<PlusOutlined />}
                                  >
                                    Add New Dosage
                                  </Button>
                                  <Form.ErrorList errors={errors} />
                                </Form.Item>
                              </>
                            )}
                          </Form.List> */}
<Form.Item
              required={true}
              
              rules={[{
                required: true,
                message:"",
              }]}
              labelCol={{ md: 7 }}
              wrapperCol={{ md: 17 }}
              label="Duration"
            >
              <Input.Group
                style={{ display: "flex" }} >
                <Form.Item
                  name={["duration", "value"]}
                  rules={[
                    {
                      required: true,
                      message: "",
                      message: "Please fill the duration",
                    },
                    Validators.checkDecimalPrescription,
                  ]}
                  noStyle
                   validateTrigger={["onChange", "onBlur"]}
                >
                  <Input placeholder="Type here"
                  //  onChange={()=>{ console.log(this.form.current?.getFieldValue("duration")?.["value"])}}
                    // onChange={(e) => dispatch(addDurationTotal(e.target.value))}
                    style={{ width: "55%" }}
                    maxLength={2}
                  />
                </Form.Item>
                <Form.Item
                  name={["duration", "measure"]}
                  noStyle
                  required={false}
                  rules={[
                    
                    { 
                      required: true,
                     message:""
                    }
                  ]}
                   validateTrigger={["onChange", "onBlur"]}
                >
                  <Select
                    className="duration-selector"
                    // onChange={(e) => dispatch(addDurationMeasure(e))}
                  onChange={()=>{ this.form.current?.getFieldValue("duration")?.["value"]}}
                    // disabled={this.props.prescriptionValue === 1 ? true : false}
                    style={{ width: "100%" }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                  >
                    <Select.Option value="Day(s)">Day(s)</Select.Option>
                    <Select.Option value="Week(s)">Week(s)</Select.Option>
                    <Select.Option value="Month(s)">Month(s)</Select.Option>
                    <Select.Option value="Year(s)">Year(s)</Select.Option>
                    <Select.Option value="Tablet(s)">Tablet(s)</Select.Option>
                    <Select.Option value="PRN">PRN</Select.Option>
                  </Select>
                </Form.Item>
              </Input.Group>
            </Form.Item>
                          <Form.Item
                            labelCol={{ md: 7 }}
                            wrapperCol={{ md: 17 }}
                            name={"intake_instruction"}
                            label={"Instruction"}
                          >
                            <Input.TextArea placeholder="Type here" />
                          </Form.Item>
                        </>
                      ) : null}
                    </Form>
                    <Button
                      className="confirm-btn"
                      style={{ float: "right",marginTop:"10px" }}
                      onClick={() => {
                        this.form.current.submit();
                        this.type_form.current.submit();
                      }}
                    >
                      Submit <ArrowRightOutlined />
                    </Button>
                  </div>
                </Drawer>
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}
export default FormAddMedicine;